export const UPDATE_DETAILS_BATCH = 'BATCH/DETAILS/UPDATE';
export const UPDATE_STATUS_BATCH = 'BATCH/STATUS/UPDATE';
export const UPDATE_TARGET_BATCH = 'BATCH/TARGET/UPDATE';
